import { getField, updateField } from "vuex-map-fields";
import API from "@/api";
import { DISABLED_FUNCTIONS_ } from "@/env";
import router, { checkRoute } from "@/router/index.js";
import lodash from "lodash";

const MAX_LIST_LEVEL = 3;

const HOME_FUNCTION_INDEX = 0;

const defaultFunctions = [
  {
    icon: {
      value: "mdi-home",
      type: "external",
    },
    title: "Home",
    route: "/home",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
  },
  {
    icon: {
      value: "mdi-folder",
      type: "external",
    },
    title: "Arquivos",
    name: "arquivos",
    route: "/arquivos",
    key: "directory.crud",
    component: () => import("@/views/DirectoryView.vue"),
  },
  {
    icon: {
      value: "PainelIcon",
      type: "internal",
    },
    title: "Painel",
    route: "/painel",
    name: "painel",
    key: "painel.read",
    show: false,
    component: () => import("@/views/PainelView.vue"),
  },
  {
    icon: {
      value: "UsuarioIcon",
      type: "internal",
    },
    title: "Usuários",
    route: "/usuario",
    name: "usuarios",
    key: "usuario.crud",
    show: false,
    component: () => import("@/views/UsuariosView.vue"),
  },
  {
    icon: {
      value: "AuditIcon",
      type: "internal",
    },
    title: "Auditoria",
    route: "/auditoria",
    name: "auditoria",
    key: "audit.read",
    show: false,
    component: () => import("@/views/AuditoriaView.vue"),
  },
  {
    icon: {
      value: "ParamsIcon",
      type: "internal",
    },
    title: "Parâmetros",
    route: "/parametro",
    name: "parametros",
    key: "parameter.crud",
    show: false,
    component: () => import("@/views/ParametrosView.vue"),
  },
  {
    icon: {
      value: "mdi-shield-account",
      type: "external",
    },
    title: "Perfis",
    route: "/perfil",
    name: "perfis",
    key: "grupo.crud",
    show: false,
    component: () => import("@/views/GroupsView.vue"),
  },
  {
    icon: {
      value: "mdi-account-lock-outline",
      type: "external",
    },
    title: "Segmentações",
    route: "/segmentacoes",
    name: "segmentacoes",
    key: "segmentation.crud",
    show: false,
    component: () => import("@/views/GroupsView.vue"),
  },
  {
    icon: {
      value: "ThemeIcon",
      type: "internal",
    },
    title: "Tema",
    route: "/tema",
    name: "tema",
    key: "tema.update",
    show: false,
    component: () => import("@/views/TemaView.vue"),
  },
  {
    icon: {
      value: "mdi-list-status",
      type: "external",
    },
    title: "Solicitações de acesso",
    name: "solicitacoes-acesso",
    route: "/solicitacoes-acesso",
    key: "solicitacao.read",
    show: false,
    component: () => import("@/views/SolicitacaoUsuariosView.vue"),
  },
  {
    icon: {
      value: "mdi-bookshelf",
      type: "external",
    },
    title: "Biblioteca de documentos",
    name: "biblioteca",
    route: "/biblioteca",
    key: "biblioteca.read",
    show: false,
    component: () => import("@/views/BibliotecaDocumentosView.vue"),
  },
  {
    icon: {
      value: "mdi-calendar-text",
      type: "external",
    },
    title: "Controle Carga",
    name: "controle-carga",
    route: "/controle-carga",
    key: "control.read",
    show: false,
    component: () => import("@/views/ControlView.vue"),
  },
  {
    icon: {
      value: "mdi-clock-outline",
      type: "external",
    },
    title: "Rotinas",
    name: "rotinas",
    route: "/rotinas",
    key: "job.read",
    show: false,
    component: () => import("@/views/JobsView.vue"),
  },
  {
    icon: {
      value: "mdi-database",
      type: "external",
    },
    title: "Fontes",
    name: "fontes",
    route: "/fontes",
    key: "fonte.read",
    show: false,
    component: () => import("@/views/FontesView.vue"),
  },
  {
    icon: {
      value: "mdi-file-table-outline",
      type: "external",
    },
    title: "Conjunto de Dados",
    name: "datasets",
    route: "/datasets",
    key: "dataset.read",
    show: false,
    component: () => import("@/views/DatasetsView.vue"),
  },
  {
    icon: {
      value: "mdi-bell",
      type: "external",
    },
    title: "Notificações de Rotina",
    name: "rotinas-notificacoes",
    route: "/rotinas-notificacoes",
    key: "job-notification.read",
    show: false,
    component: () => import("@/views/JobNotificationView.vue"),
  },
  {
    icon: {
      value: "mdi-cog-outline",
      type: "external",
    },
    title: "Editor de consultas",
    name: "query-editor",
    route: "/query-editor",
    key: "query-editor.crud",
    show: false,
    component: () => import("@/views/QueryEditorView.vue"),
  },
];

let disabledFunctionalities =
  process.env.NODE_ENV === "production"
    ? DISABLED_FUNCTIONS_
    : process.env.VUE_APP_DISABLED_FUNCTIONALITY;

if (!disabledFunctionalities) {
  disabledFunctionalities = [];
}

const initialState = () => ({
  externalFunctions: [],
  quickAccessFunctions: [],
  menu: [],
  routes: [],
  functionsLoaded: false,
});

export const state = initialState();

export const getters = {
  getField,
};

export const actions = {
  async loadExternalFunctions({ dispatch, commit }, authorities) {
    commit("updateField", { path: "functionsLoaded", value: true });
    await dispatch("getExternalFunctions");
    commit("loadDynamicFunctions", authorities);
    commit("updateField", { path: "functionsLoaded", value: false });
  },
  async getExternalFunctions({ commit }) {
    commit("updateField", { path: "functionsLoaded", value: true });
    let result = await API.axios.get("/bff/api/v1/static/menu/menu.json");

    if (result.status === 200) {
      commit("updateField", { path: `externalFunctions`, value: result.data });
    } else {
      throw new Error("Algo deu errado! Erro 0x01");
    }
    commit("updateField", { path: "functionsLoaded", value: false });
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

export const mutations = {
  updateField,
  loadDynamicFunctions(state, authorities) {
    let tempMenu = [defaultFunctions[HOME_FUNCTION_INDEX]];

    checkAddFunctions(
      state.externalFunctions,
      tempMenu,
      state.routes,
      authorities,
      MAX_LIST_LEVEL
    );
    let routes = lodash.cloneDeep(state.routes);

    for (let index in routes) {
      router.addRoute(routes[index]);
    }

    let tempMyFunctions = [];
    tempMenu.forEach((item, index) => {
      if (index === HOME_FUNCTION_INDEX) return;

      if (item.submenu) {
        item.submenu.forEach((subItem) => {
          if (subItem.submenu) {
            subItem.submenu.forEach((subSubItem) => {
              tempMyFunctions.push(
                formatQuickAccessFunction(subSubItem, item.title)
              );
            });
          } else {
            tempMyFunctions.push(
              formatQuickAccessFunction(subItem, item.title)
            );
          }
        });
      } else {
        tempMyFunctions.push(formatQuickAccessFunction(item));
      }
    });

    state.quickAccessFunctions = tempMyFunctions;
    state.menu = tempMenu;
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
};

function formatQuickAccessFunction(item, parentMenu) {
  return {
    name: item.name,
    parentMenu: parentMenu,
    title: item.title,
    route: item.route,
    icon: item.icon,
  };
}

function checkAddFunctions(
  externalFunction,
  destMenu,
  routes,
  authorities,
  listLevel
) {
  if (listLevel === 0) return;
  for (let index in externalFunction) {
    if (!disabledFunctionalities.includes(externalFunction[index].name)) {
      if (!externalFunction[index].submenu?.length) {
        let item;
        if (externalFunction[index].type === "internal") {
          item = formatInternalFunction(externalFunction[index]);
        } else {
          item = formatExternalFunction(externalFunction[index]);
        }

        if (authorities.includes(item.key) && item) {
          destMenu.push(item);
          routes.push(formatRoutes(item));
        }
      } else {
        let tempMenu = [];
        checkAddFunctions(
          externalFunction[index].submenu,
          tempMenu,
          routes,
          authorities,
          listLevel - 1
        );
        if (tempMenu.length) {
          destMenu.push({
            icon: externalFunction[index].icon,
            title: externalFunction[index].title,
            name: externalFunction[index].name,
            show: false,
            active: false,
            submenu: tempMenu,
          });
        }
      }
    }
  }
}

function formatInternalFunction(origArray) {
  let obj = defaultFunctions.find((item) => item.name === origArray.name);
  if (!obj) return null;
  obj.key = origArray.key ? origArray.key : obj.key;
  obj.title = origArray.title ? origArray.title : obj.title;
  obj.icon = origArray.icon ? origArray.icon : obj.icon;
  obj.route = origArray.route ? origArray.route : obj.route;
  return obj;
}

function formatExternalFunction(origArray) {
  return {
    icon: origArray.icon,
    title: origArray.title,
    name: origArray.name,
    route: origArray.route,
    key: origArray.key,
    show: false,
    component: () => import("@/views/ExternalAppView.vue"),
    url: origArray.url,
  };
}

function formatRoutes(object) {
  return {
    path: object.route,
    name: object.name,
    component: object.component,
    meta: {
      showSystemBars: true,
      requiresAuth: true,
      url: object.type !== "internal" ? object.url : null,
      title: object.title,
    },
    beforeEnter(to, from, next) {
      checkRoute(next, to, object.key);
    },
  };
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
